import Vue from "vue";
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import App from "./App.vue";
import router from "@/router";
import Vant from "vant";
import "vant/lib/index.css";
import "amfe-flexible";
import store from "./store";
import api from "./api";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import { Loading } from "vant";
import VueLazyload from 'vue-lazyload';
Vue.config.productionTip = false;
Vue.prototype.$api = api;

Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(Loading);
Vue.use(iView);
Vue.use(Viewer);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/images/no.png'),
  loading: require('./assets/images/moren.jpg'),
  attempt: 1,
  listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove']
});

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (store.state.isLogin) {
      store.commit("setLoginModalState", false);
      next();
    } else {
      store.commit("setLoginModalState", true);
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
